// Components
import { Card, CardContent } from '@/common-utils/components/ui/card';
import { Skeleton } from '@/common-utils/components/ui/skeleton';

/**
 * @returns {JSX} VerticalBarChartSkeleton
 */
function VerticalBarChartSkeleton() {
    return (
        <Card className='border border-gray-300 rounded-md'>
            <CardContent>
                <div className='flex flex-col items-start gap-2 py-2 px-2'>
                    <Skeleton className='h-6 w-28 max-w-[40%] shrink-0 rounded-md sm:max-w-[320px]' />
                    <Skeleton className='h-4 w-20 max-w-[35%] shrink-0 rounded-md sm:max-w-[240px]' />
                </div>

                <div className='flex w-full items-end justify-center px-4 pt-6 pb-3'>
                    <div className='flex w-full max-w-full items-end justify-between gap-3'>
                        {[0, 1, 2, 3].map((groupItem) => (
                            <div key={groupItem} className='flex min-w-0 flex-1 flex-col items-center gap-2'>
                                <div className='flex w-full items-end justify-center gap-1'>
                                    {[0, 1].map((item) => (
                                        <Skeleton
                                            key={item}
                                            className='w-full max-w-8 rounded-[4px] min-h-32'
                                            style={{ height: '64px' }}
                                        />
                                    ))}
                                </div>
                                <Skeleton className='h- w-10 rounded-md' />
                            </div>
                        ))}
                    </div>
                </div>

                <div className='flex w-full items-center justify-center gap-3 px-4 pb-4'>
                    <Skeleton className='h-3.5 w-16 rounded-md' />
                    <Skeleton className='h-3.5 w-16 rounded-md' />
                </div>
            </CardContent>
        </Card>
    );
}

export default VerticalBarChartSkeleton;